import { useMemo, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { usePagination, useRowSelect, useTable, useFilters } from 'react-table';
// import styled from 'styled-components';
import { clearTable } from '../../../../../../Redux/slices/table';

import ReactTableRender from '../../../../../../Components/ReactTable/ReactTableRender';
import { Button } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import DefaultColumnFilter from '../../../../../../Components/ReactTable/Filters/DefaultColumnFilter';

// const StyledDefaultColumnFilter = styled.input`
//   width: 100%;
// `;
// // Define a default UI for filtering
// const DefaultColumnFilter = ({ column: { filterValue, preFilteredRows, setFilter } }) => {
//   const count = preFilteredRows.length;
//   return (
//     <StyledDefaultColumnFilter
//       value={filterValue || ''}
//       onChange={(e) => {
//         setFilter(e.target.value || undefined); // Set undefined to remove the filter entirely
//       }}
//       placeholder={`Search ${count} records...`}
//     />
//   );
// };

function ParticipantApprovalTable({ data, columns, dataFetcher, handleApprove, showGoto = true }) {
  const dispatch = useDispatch();
  const pageNum = useSelector((state) => state.table.pageNum);
  const loading = useSelector((state) => state.table.loading);
  const totalCount = useSelector((state) => state.table.totalCount);

  const defaultColumn = useMemo(
    () => ({
      // Let's set up our default Filter UI
      Filter: DefaultColumnFilter
    }),
    []
  );

  // Use the state and functions returned from useTable to build your UI
  const {
    headerGroups,
    getTableProps,
    getTableBodyProps,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    state: { pageIndex }
  } = useTable(
    {
      columns,
      data: data,
      initialState: { pageIndex: 0 },
      manualPagination: true,
      pageCount: pageNum,
      defaultCanFilter: false,
      defaultColumn
      // manualFilters: true
    },
    useFilters,
    usePagination,
    useRowSelect,
    (hooks) => {
      hooks.visibleColumns.push((columns) => [
        ...columns,
        {
          id: 'selection',
          Header: () => (
            <div>
              <FormattedMessage id="actions" />
            </div>
          ),
          Cell: ({ row }) => (
            <div>
              <Button onClick={() => handleApprove(row.original.id)}>
                <FormattedMessage id="button.approve" />
              </Button>
            </div>
          )
        }
      ]);
    }
  );

  useEffect(() => {
    dataFetcher({ index: pageIndex });
  }, [pageIndex]);
  useEffect(() => {
    return () => {
      dispatch(clearTable());
    };
  }, []);
  const pageCountArray = useMemo(
    () => Array.from({ length: Math.ceil(totalCount / 10) }, (v, i) => i + 1),
    [totalCount]
  );

  return (
    <>
      <ReactTableRender
        getTableProps={getTableProps}
        headerGroups={headerGroups}
        getTableBodyProps={getTableBodyProps}
        page={page}
        prepareRow={prepareRow}
        totalCount={totalCount}
        gotoPage={gotoPage}
        previousPage={previousPage}
        pageCount={pageCount}
        pageCountArray={pageCountArray}
        pageNum={pageNum}
        showGoto={showGoto}
        nextPage={nextPage}
        pageIndex={pageIndex}
        canNextPage={canNextPage}
        canPreviousPage={canPreviousPage}
        loading={loading}
      />
    </>
  );
}

export default ParticipantApprovalTable;
